import React, { Component } from 'react'
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'
import Route from './router/RouteWrapper'
import LoginScreen from './screens/LoginScreen'
import CalendarScreen from './screens/CalendarScreen'
import HelpScreen from './screens/HelpScreen'
import { inject, observer } from 'mobx-react'
import ProfileScreen from './screens/ProfileScreen'
import RootComponent from './components/RootComponent'
import { Dimmer, Loader } from 'semantic-ui-react'
import ClientsScreen from './screens/Clients/ClientsScreen'
import ClientsViewScreen from './screens/Clients/ClientsViewScreen'
import UsersScreen from './screens/Users/UsersScreen'
import RolesScreen from './screens/Roles/RolesScreen'
import EmailsScreen from './screens/Emails/EmailsScreen'
import EventsScreen from './screens/Events/EventsScreen'
import ArchivesScreen from './screens/Events/ArchivesScreen'
import EventsCreateScreen from './screens/Events/EventsCreateScreen'
import ClientsCreateScreen from './screens/Clients/ClientsCreateScreen'
import ClientsSyncedScreen from './screens/Clients/Synced/ClientsSyncedScreen'
import EmailsEditScreen from './screens/Emails/EmailsEditScreen'
import InspectionsAddressesScreen from './screens/Clients/InspectionsAddressesScreen'
import ClientsSyncedImportScreen from './screens/Clients/Synced/ClientsSyncedImportScreen'
import InspectionsAddressesEquipmentCreateScreen
  from './screens/Clients/Equipment/InspectionsAddressesEquipmentCreateScreen'
import UsersEditScreen from './screens/Users/UsersEditScreen'
import UsersCreateScreen from './screens/Users/UsersCreateScreen'
import RolesEditScreen from './screens/Roles/RolesEditScreen'
import EventsEventScreen from './screens/Events/EventsEventScreen'
import AuthenticationStore from './stores/AuthenticationStore'
import EventsSubmitScreen from './screens/Events/EventsSubmitScreen'
import EventsReviewScreen from './screens/Events/EventsReviewScreen'
import ArchivesEventScreen from './screens/Events/ArchivesEventScreen'
import NextEventsScreen from './screens/NextEventsScreen'
import EventsEditScreen from './screens/Events/EventsEditScreen'
import PrintScreen from './screens/PrintScreen'
import PrintLayout from './layouts/PrintLayout'
import PrintWithJwtScreen from './screens/PrintWithJwtScreen'
import ClientsLoginScreen from './screens/ClientsLoginScreen'

@inject('authenticationStore')
@observer
class App extends Component {
  static propTypes = {
    authenticationStore: PropTypes.instanceOf(AuthenticationStore)
  }

  render () {
    const { initializing } = this.props.authenticationStore
    if (initializing) {
      return (
        <Dimmer active={initializing}>
          <Loader>
            Chargement
          </Loader>
        </Dimmer>
      )
    }
    return (
      <>
        <Router>
          <Switch>
            <Route exact path='/' component={RootComponent} isPrivate={false} />
            <Route exact path='/login' component={LoginScreen} isPrivate={false} skipIfLoggedIn />
            <Route exact path='/next-events' component={NextEventsScreen} isPrivate isClient />
            <Route exact path='/profile' component={ProfileScreen} isPrivate />
            <Route exact path='/clients' component={ClientsScreen} isPrivate />
            <Route exact path='/clients/login/:uuid' component={ClientsLoginScreen} isPrivate={false} skipIfLoggedIn />
            <Route exact path='/clients/create' component={ClientsCreateScreen} isPrivate />
            <Route exact path='/clients/view/:clientId' component={ClientsViewScreen} isPrivate />
            <Route exact path='/clients/inspections-addresses/create/:clientId' component={InspectionsAddressesScreen} isPrivate />
            <Route exact path='/clients/inspections-addresses/edit/:clientId/:addressId' component={InspectionsAddressesScreen} isPrivate />
            <Route exact path='/clients/inspections-addresses-equipment/create/:clientsAddressId' component={InspectionsAddressesEquipmentCreateScreen} isPrivate />
            <Route exact path='/clients/inspections-addresses-equipment/edit/:clientsAddressEquipmentId' component={InspectionsAddressesEquipmentCreateScreen} isPrivate />
            <Route exact path='/clients/synced' component={ClientsSyncedScreen} isPrivate />
            <Route exact path='/clients/synced/:clientId' component={ClientsSyncedImportScreen} isPrivate />
            <Route exact path='/calendars' component={CalendarScreen} isPrivate />
            <Route exact path='/events' component={EventsScreen} isPrivate />
            <Route exact path='/events/create/:clientId/:clientAddressId?/:clientAddressEquipmentId?' component={EventsCreateScreen} isPrivate />
            <Route exact path='/events/edit/:eventId' component={EventsEditScreen} isPrivate />
            <Route exact path='/events/event/:eventId' component={EventsEventScreen} isPrivate />
            <Route exact path='/events/submit/:eventId' component={EventsSubmitScreen} isPrivate />
            <Route exact path='/events/review/:eventId' component={EventsReviewScreen} isPrivate />
            <Route exact path='/archives' component={ArchivesScreen} isPrivate />
            <Route exact path='/archives/event/:eventId' component={ArchivesEventScreen} isPrivate />
            <Route exact path='/print/event/:eventId' component={PrintScreen} isPrivate layout={PrintLayout} />
            <Route exact path='/print/event/:eventId/:jwt' component={PrintWithJwtScreen} isPrivate={false} layout={PrintLayout} />
            <Route exact path='/emails' component={EmailsScreen} isPrivate />
            <Route exact path='/emails/edit/:emailCode' component={EmailsEditScreen} isPrivate />
            <Route exact path='/users' component={UsersScreen} isPrivate />
            <Route exact path='/users/edit/:userId' component={UsersEditScreen} isPrivate />
            <Route exact path='/users/create' component={UsersCreateScreen} isPrivate />
            <Route exact path='/roles' component={RolesScreen} isPrivate />
            <Route exact path='/roles/create' component={RolesEditScreen} isPrivate />
            <Route exact path='/roles/edit/:roleId' component={RolesEditScreen} isPrivate />
            <Route exact path='/help' component={HelpScreen} isPrivate />
          </Switch>
        </Router>
      </>
    )
  }
}

export default App
